// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bf29e4b7","455":"f3ac72e2","977":"22588a27"}[chunkId] + ".chunk.js";
};